function init() {
  $(document).on('click', '[data-close-nag-alert]', closeNagAlert);
}

function closeNagAlert(e) {
  e.preventDefault();
  var $closeBtn = $(this);
  var $nagAlert = $closeBtn.parents('[data-nag-alert]');
  $.post($nagAlert.data('close-alert-path'));
  $nagAlert.hide();
}

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/nag_alerts.js